import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { SidepanelTypes } from './model/sidepanel.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { VersionModalComponent } from './version-modal/version-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../basic-features";
import * as i3 from "@angular/cdk/layout";
import * as i4 from "../../shared";
import * as i5 from "../contact-form-sidemodal";
import * as i6 from "@angular/common";
import * as i7 from "angular-svg-icon";
import * as i8 from "primeng/divider";
import * as i9 from "primeng/tree";
import * as i10 from "primeng/api";
import * as i11 from "../../basic-features/icon-v3/icon.component";
import * as i12 from "../../basic-features/search-bar-v2/search-bar-v2.component";
import * as i13 from "primeng/tooltip";
import * as i14 from "primeng/dropdown";
import * as i15 from "@angular/forms";
import * as i16 from "../../shared/directive/tooltip-on-ellipsis-v2.directive";
import * as i17 from "ngx-skeleton-loader";
import * as i18 from "@ngx-translate/core";
const _c0 = ["changeViewDropdown"];
const _c1 = a0 => ({
  "mobile-view-open": a0
});
const _c2 = a0 => ({
  "slim-bar": a0
});
const _c3 = a0 => ({
  "no-search": a0
});
const _c4 = () => ({
  height: "40px",
  width: "40px",
  "margin-bottom": 0
});
const _c5 = () => ({
  height: "24px",
  width: "107px",
  "margin-bottom": 0
});
const _c6 = a0 => ({
  hide: a0
});
const _c7 = (a0, a1) => ({
  selected: a0,
  disabled: a1
});
const _c8 = () => ({
  height: "24px",
  width: "24px",
  "margin-bottom": 0
});
const _c9 = a0 => ({
  selected: a0
});
const _c10 = (a0, a1, a2) => ({
  full: a0,
  slim: a1,
  mobile: a2
});
function SidebarV2Component_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵlistener("click", function SidebarV2Component_div_0_div_3_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleSlimView());
    });
    i0.ɵɵelement(1, "geaui-icon-v3", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("file", ctx_r2.slimView ? "16px_chevron-right" : "16px_chevron-left");
  }
}
function SidebarV2Component_div_0_svg_icon_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "svg-icon", 23);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r2.devisionIconPath)("svgAriaLabel", ctx_r2.devisionName + " icon");
  }
}
function SidebarV2Component_div_0_ngx_skeleton_loader_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-skeleton-loader", 24);
  }
  if (rf & 2) {
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c4));
  }
}
function SidebarV2Component_div_0_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.devisionName);
  }
}
function SidebarV2Component_div_0_span_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c5));
  }
}
function SidebarV2Component_div_0_div_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "div", 27);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function SidebarV2Component_div_0_div_10_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.openSwitchViewDropdown());
    });
    i0.ɵɵelement(3, "geaui-icon-v3", 28);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("pTooltip", i0.ɵɵpipeBind1(2, 1, "UI.LIB.SIDEBAR.SWITCH-VIEW"));
  }
}
function SidebarV2Component_div_0_p_dropdown_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-dropdown", 29, 1);
    i0.ɵɵtwoWayListener("ngModelChange", function SidebarV2Component_div_0_p_dropdown_11_Template_p_dropdown_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r2.selectedView, $event) || (ctx_r2.selectedView = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("onChange", function SidebarV2Component_div_0_p_dropdown_11_Template_p_dropdown_onChange_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.viewChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const sidebar_r6 = i0.ɵɵreference(1);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.selectedView);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c6, ctx_r2.slimView && ctx_r2._adminViewNavigationItems))("options", ctx_r2.sidebarViewOptions)("panelStyleClass", ctx_r2.slimView ? "slim-view" : "normal-view")("appendTo", ctx_r2.slimView ? sidebar_r6 : null);
  }
}
function SidebarV2Component_div_0_geaui_search_bar_v2_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-search-bar-v2", 30);
  }
  if (rf & 2) {
    i0.ɵɵproperty("showBottomBorderOnly", true)("hasProminentButton", false)("placeholder", "Search");
  }
}
function SidebarV2Component_div_0_geaui_icon_v3_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v3", 31);
    i0.ɵɵlistener("click", function SidebarV2Component_div_0_geaui_icon_v3_13_Template_geaui_icon_v3_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.slimView = false);
    });
    i0.ɵɵelementEnd();
  }
}
function SidebarV2Component_div_0_p_divider_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 32);
  }
}
function SidebarV2Component_div_0_ng_template_17_geaui_icon_v3_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v3", 41);
  }
  if (rf & 2) {
    const node_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("fileSize", 16)("file", node_r9.icon)("color", node_r9 === ctx_r2.selectedNode ? "blue" : (node_r9.data == null ? null : node_r9.data.disabled) ? "grey" : "black")("baseUrl", node_r9.iconBaseUrl)("appKey", node_r9.iconAppKey);
  }
}
function SidebarV2Component_div_0_ng_template_17_ngx_skeleton_loader_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-skeleton-loader", 24);
  }
  if (rf & 2) {
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c8));
  }
}
function SidebarV2Component_div_0_ng_template_17_span_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 42);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function SidebarV2Component_div_0_ng_template_17_span_7_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const node_r9 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(node_r9.expanded = !node_r9.expanded);
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c7, node_r9 === ctx_r2.selectedNode, node_r9.data == null ? null : node_r9.data.disabled))("pTooltip", i0.ɵɵpipeBind1(1, 3, node_r9.label));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, node_r9.label), " ");
  }
}
function SidebarV2Component_div_0_ng_template_17_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 43);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c5));
  }
}
function SidebarV2Component_div_0_ng_template_17_geaui_icon_v3_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v3", 44);
    i0.ɵɵlistener("click", function SidebarV2Component_div_0_ng_template_17_geaui_icon_v3_9_Template_geaui_icon_v3_click_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const node_r9 = i0.ɵɵnextContext().$implicit;
      node_r9.expanded = !node_r9.expanded;
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("file", node_r9.expanded ? "16px_chevron-up" : "16px_chevron-down")("color", node_r9 === ctx_r2.selectedNode ? "blue" : (node_r9.data == null ? null : node_r9.data.disabled) ? "grey" : "black");
  }
}
function SidebarV2Component_div_0_ng_template_17_ngx_skeleton_loader_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-skeleton-loader", 45);
  }
  if (rf & 2) {
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c8));
  }
}
function SidebarV2Component_div_0_ng_template_17_div_11_li_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 50);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function SidebarV2Component_div_0_ng_template_17_div_11_li_8_Template_li_click_0_listener($event) {
      const child_r13 = i0.ɵɵrestoreView(_r12).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.onSlimChildClick(child_r13, $event));
    });
    i0.ɵɵelement(3, "geaui-icon-v3", 41);
    i0.ɵɵelementStart(4, "span", 51);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const child_r13 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(15, _c7, child_r13 === ctx_r2.activeRouteNode, child_r13.data == null ? null : child_r13.data.disabled))("pTooltip", (child_r13.data == null ? null : child_r13.data.disabled) ? i0.ɵɵpipeBind1(1, 9, "X.INFO.NO_ACCESS.RIGHT_MISSING") : i0.ɵɵpipeBind1(2, 11, child_r13.label));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("fileSize", 16)("file", child_r13.icon)("color", child_r13 === ctx_r2.activeRouteNode ? "blue" : (child_r13.data == null ? null : child_r13.data.disabled) ? "grey" : "black")("baseUrl", child_r13.iconBaseUrl)("appKey", child_r13.iconAppKey);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(18, _c7, child_r13 === ctx_r2.activeRouteNode, child_r13.data == null ? null : child_r13.data.disabled));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 13, child_r13.label));
  }
}
function SidebarV2Component_div_0_ng_template_17_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46)(1, "div", 47)(2, "div", 48);
    i0.ɵɵelement(3, "geaui-icon-v3", 41);
    i0.ɵɵelementStart(4, "span", 43);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "ul");
    i0.ɵɵtemplate(8, SidebarV2Component_div_0_ng_template_17_div_11_li_8_Template, 7, 21, "li", 49);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const node_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("fileSize", 16)("file", node_r9.icon)("color", "black")("baseUrl", node_r9.iconBaseUrl)("appKey", node_r9.iconAppKey);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 7, node_r9.label));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", node_r9.children);
  }
}
function SidebarV2Component_div_0_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function SidebarV2Component_div_0_ng_template_17_Template_div_click_0_listener($event) {
      const node_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onNodeClicked(node_r9, $event));
    });
    i0.ɵɵelementStart(2, "div", 34);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, SidebarV2Component_div_0_ng_template_17_geaui_icon_v3_5_Template, 1, 5, "geaui-icon-v3", 35)(6, SidebarV2Component_div_0_ng_template_17_ngx_skeleton_loader_6_Template, 1, 2, "ngx-skeleton-loader", 10)(7, SidebarV2Component_div_0_ng_template_17_span_7_Template, 4, 10, "span", 36)(8, SidebarV2Component_div_0_ng_template_17_span_8_Template, 2, 2, "span", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, SidebarV2Component_div_0_ng_template_17_geaui_icon_v3_9_Template, 1, 2, "geaui-icon-v3", 38)(10, SidebarV2Component_div_0_ng_template_17_ngx_skeleton_loader_10_Template, 1, 2, "ngx-skeleton-loader", 39)(11, SidebarV2Component_div_0_ng_template_17_div_11_Template, 9, 9, "div", 40);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r9 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(16, _c7, node_r9 === ctx_r2.selectedNode, node_r9.data == null ? null : node_r9.data.disabled));
    i0.ɵɵattribute("data-label", i0.ɵɵpipeBind1(1, 10, node_r9.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pTooltip", (node_r9.data == null ? null : node_r9.data.disabled) ? i0.ɵɵpipeBind1(3, 12, "X.INFO.NO_ACCESS.RIGHT_MISSING") : ctx_r2.slimView ? i0.ɵɵpipeBind1(4, 14, node_r9.label) : "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (!ctx_r2.slimView || ctx_r2.mobileView) && !ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (!ctx_r2.slimView || ctx_r2.mobileView) && ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r9.children && (!ctx_r2.slimView || ctx_r2.mobileView) && !ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r9.children && (!ctx_r2.slimView || ctx_r2.mobileView) && ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.slimView && !ctx_r2.mobileView && ctx_r2.openedSlimSubmenuNode === node_r9 && (node_r9.children == null ? null : node_r9.children.length));
  }
}
function SidebarV2Component_div_0_Conditional_18_ng_template_3_geaui_icon_v3_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v3", 58);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const node_r15 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("fileSize", 16)("file", node_r15.icon)("baseUrl", node_r15.iconBaseUrl)("appKey", node_r15.iconAppKey)("color", node_r15 === ctx_r2.selectedNode ? "blue" : "black")("pTooltip", i0.ɵɵpipeBind1(1, 6, ctx_r2.slimView && !ctx_r2.mobileView ? node_r15.label : ""));
  }
}
function SidebarV2Component_div_0_Conditional_18_ng_template_3_ngx_skeleton_loader_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-skeleton-loader", 24);
  }
  if (rf & 2) {
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c8));
  }
}
function SidebarV2Component_div_0_Conditional_18_ng_template_3_span_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 59);
    i0.ɵɵlistener("dblclick", function SidebarV2Component_div_0_Conditional_18_ng_template_3_span_5_Template_span_dblclick_0_listener($event) {
      i0.ɵɵrestoreView(_r16);
      const node_r15 = i0.ɵɵnextContext().$implicit;
      node_r15.expanded = !node_r15.expanded;
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r15 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c9, node_r15 === ctx_r2.selectedNode));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, node_r15.label), " ");
  }
}
function SidebarV2Component_div_0_Conditional_18_ng_template_3_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 43);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c5));
  }
}
function SidebarV2Component_div_0_Conditional_18_ng_template_3_geaui_icon_v3_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v3", 44);
    i0.ɵɵlistener("click", function SidebarV2Component_div_0_Conditional_18_ng_template_3_geaui_icon_v3_7_Template_geaui_icon_v3_click_0_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const node_r15 = i0.ɵɵnextContext().$implicit;
      node_r15.expanded = !node_r15.expanded;
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r15 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("file", node_r15.expanded ? "16px_chevron-up" : "16px_chevron-down")("color", node_r15 === ctx_r2.selectedNode ? "blue" : "black");
  }
}
function SidebarV2Component_div_0_Conditional_18_ng_template_3_ngx_skeleton_loader_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-skeleton-loader", 24);
  }
  if (rf & 2) {
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c8));
  }
}
function SidebarV2Component_div_0_Conditional_18_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "div", 55);
    i0.ɵɵtemplate(3, SidebarV2Component_div_0_Conditional_18_ng_template_3_geaui_icon_v3_3_Template, 2, 8, "geaui-icon-v3", 56)(4, SidebarV2Component_div_0_Conditional_18_ng_template_3_ngx_skeleton_loader_4_Template, 1, 2, "ngx-skeleton-loader", 10)(5, SidebarV2Component_div_0_Conditional_18_ng_template_3_span_5_Template, 3, 6, "span", 57)(6, SidebarV2Component_div_0_Conditional_18_ng_template_3_span_6_Template, 2, 2, "span", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, SidebarV2Component_div_0_Conditional_18_ng_template_3_geaui_icon_v3_7_Template, 1, 2, "geaui-icon-v3", 38)(8, SidebarV2Component_div_0_Conditional_18_ng_template_3_ngx_skeleton_loader_8_Template, 1, 2, "ngx-skeleton-loader", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r15 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c9, node_r15 === ctx_r2.selectedNode));
    i0.ɵɵattribute("data-label", i0.ɵɵpipeBind1(1, 8, node_r15.label));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (!ctx_r2.slimView || ctx_r2.mobileView) && !ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (!ctx_r2.slimView || ctx_r2.mobileView) && ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r15.children && (!ctx_r2.slimView || ctx_r2.mobileView) && !ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r15.children && (!ctx_r2.slimView || ctx_r2.mobileView) && ctx_r2.loading);
  }
}
function SidebarV2Component_div_0_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "p-divider", 52);
    i0.ɵɵelementStart(2, "p-tree", 53);
    i0.ɵɵtwoWayListener("selectionChange", function SidebarV2Component_div_0_Conditional_18_Template_p_tree_selectionChange_2_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r2.selectedBottomNode, $event) || (ctx_r2.selectedBottomNode = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("selectionChange", function SidebarV2Component_div_0_Conditional_18_Template_p_tree_selectionChange_2_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onBottomClick($event));
    });
    i0.ɵɵtemplate(3, SidebarV2Component_div_0_Conditional_18_ng_template_3_Template, 9, 12, "ng-template", 19);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3, !ctx_r2.hasSearch));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("selection", ctx_r2.selectedBottomNode);
    i0.ɵɵproperty("metaKeySelection", false)("value", ctx_r2.slimView && !ctx_r2.mobileView ? ctx_r2.flatBottomNavigation : ctx_r2._bottomNavigation);
  }
}
function SidebarV2Component_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4, 0)(2, "div", 5);
    i0.ɵɵtemplate(3, SidebarV2Component_div_0_div_3_Template, 2, 1, "div", 6);
    i0.ɵɵelementStart(4, "div", 7)(5, "div", 8);
    i0.ɵɵtemplate(6, SidebarV2Component_div_0_svg_icon_6_Template, 1, 2, "svg-icon", 9)(7, SidebarV2Component_div_0_ngx_skeleton_loader_7_Template, 1, 2, "ngx-skeleton-loader", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, SidebarV2Component_div_0_span_8_Template, 2, 1, "span", 11)(9, SidebarV2Component_div_0_span_9_Template, 2, 2, "span", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, SidebarV2Component_div_0_div_10_Template, 4, 3, "div", 12)(11, SidebarV2Component_div_0_p_dropdown_11_Template, 2, 7, "p-dropdown", 13)(12, SidebarV2Component_div_0_geaui_search_bar_v2_12_Template, 1, 3, "geaui-search-bar-v2", 14)(13, SidebarV2Component_div_0_geaui_icon_v3_13_Template, 1, 0, "geaui-icon-v3", 15)(14, SidebarV2Component_div_0_p_divider_14_Template, 1, 0, "p-divider", 16);
    i0.ɵɵelementStart(15, "div", 17)(16, "p-tree", 18);
    i0.ɵɵlistener("onNodeSelect", function SidebarV2Component_div_0_Template_p_tree_onNodeSelect_16_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onNodeSelected($event.node));
    })("onNodeUnselect", function SidebarV2Component_div_0_Template_p_tree_onNodeUnselect_16_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onNodeDeselected($event.node));
    });
    i0.ɵɵtemplate(17, SidebarV2Component_div_0_ng_template_17_Template, 12, 19, "ng-template", 19);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(18, SidebarV2Component_div_0_Conditional_18_Template, 4, 6, "div", 20);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c1, ctx_r2.mobileView && ctx_r2.mobileViewOpen));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c2, ctx_r2.slimView && !ctx_r2.mobileView));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.mobileView);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("background-color", ctx_r2.loading ? "" : ctx_r2.devisionIconBackgroundColor);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (!ctx_r2.slimView || ctx_r2.mobileView) && !ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (!ctx_r2.slimView || ctx_r2.mobileView) && ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.slimView && ctx_r2._adminViewNavigationItems.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2._adminViewNavigationItems.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.hasSearch && (!ctx_r2.slimView || ctx_r2.mobileView));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.hasSearch && ctx_r2.slimView && !ctx_r2.mobileView);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.hasSearch);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(23, _c3, !ctx_r2.hasSearch));
    i0.ɵɵadvance();
    i0.ɵɵproperty("selection", ctx_r2.selectedNode)("value", ctx_r2.isAdminViewActive ? ctx_r2.slimView && !ctx_r2.mobileView ? ctx_r2.adminViewFlatItems : ctx_r2._adminViewNavigationItems : ctx_r2.slimView && !ctx_r2.mobileView ? ctx_r2.flatItems : ctx_r2._navigationItems)("metaKeySelection", false);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2._bottomNavigation.length ? 18 : -1);
  }
}
function SidebarV2Component_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 60)(1, "geaui-icon-v3", 62);
    i0.ɵɵlistener("click", function SidebarV2Component_Conditional_1_Conditional_1_Template_geaui_icon_v3_click_1_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.selectedTemplate = undefined);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("clickable", true);
  }
}
function SidebarV2Component_Conditional_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SidebarV2Component_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, SidebarV2Component_Conditional_1_Conditional_1_Template, 2, 1, "div", 60)(2, SidebarV2Component_Conditional_1_ng_container_2_Template, 1, 0, "ng-container", 61);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(4, _c10, !ctx_r2.slimView, ctx_r2.slimView, ctx_r2.mobileView));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.getTemplateSidePanel().closeable !== false ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r2.getTemplateSidePanel().ref)("ngComponentOutletInputs", ctx_r2.getTemplateSidePanel().inputs);
  }
}
export class SidebarV2Component {
  router;
  changeDect;
  dialog;
  destroyed;
  breakpointObserver;
  headerUtilService;
  complexDialogService;
  complexDialogV3Service;
  contactFormService;
  SUPPORT_APP_URL_MISSING = 'ERROR - Please provide the Support App base Url in the sidebar configuration of the Contact form, to ensure the correct function. For more Information visit the documentation of the sidebar: https://geagroup.atlassian.net/wiki/spaces/GEN/pages/792264817/Sidebar+V2+Component#Configuring-the-bottom-section';
  devisionIconPath;
  devisionIconBackgroundColor;
  devisionName;
  loading = false;
  set navigationItems(navItems) {
    this._navigationItems = this.mapNavigationItems(navItems);
    // no-unused-vars is disabled here because the flatItems are used in the template
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.flatItems = this._navigationItems;
    this.updateActiveNavigationItem();
  }
  set adminViewNavigationItems(navItems) {
    this._adminViewNavigationItems = this.mapNavigationItems(navItems);
    // no-unused-vars is disabled here because the flatItems are used in the template
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.adminViewFlatItems = this._adminViewNavigationItems;
    this.updateActiveNavigationItem();
  }
  hasSearch = false;
  slimView = false;
  set bottomNavigation(bottomItems) {
    this._bottomNavigation = bottomItems.map(item => ({
      key: item.key,
      icon: item.icon,
      label: item.label,
      data: item
    }));
    this.checkContactFormSidePanelConfig(bottomItems);
  }
  customActionTriggered = new EventEmitter();
  changeViewDropdown;
  get flatBottomNavigation() {
    return this._bottomNavigation;
  }
  selectedNode;
  _navigationItems = [];
  _adminViewNavigationItems = [];
  isAdminViewActive = false;
  selectedBottomNode;
  selectedTemplate;
  _bottomNavigation = [];
  flatItems = [];
  adminViewFlatItems = [];
  routerSubscription;
  mobileView = false;
  mobileViewOpen = false;
  url = '';
  sidebarViewOptions = [{
    label: 'Default View',
    value: 'DEFAULT_VIEW'
  }, {
    label: 'Admin View',
    value: 'ADMIN_VIEW'
  }];
  selectedView = 'DEFAULT_VIEW';
  isErrorForm = false;
  errorCode = '';
  openedSlimSubmenuNode;
  activeRouteNode;
  SidepanelTypes = SidepanelTypes;
  constructor(router, changeDect, dialog, destroyed, breakpointObserver, headerUtilService, complexDialogService, complexDialogV3Service, contactFormService) {
    this.router = router;
    this.changeDect = changeDect;
    this.dialog = dialog;
    this.destroyed = destroyed;
    this.breakpointObserver = breakpointObserver;
    this.headerUtilService = headerUtilService;
    this.complexDialogService = complexDialogService;
    this.complexDialogV3Service = complexDialogV3Service;
    this.contactFormService = contactFormService;
  }
  ngOnInit() {
    this.routerSubscription = this.router.events.subscribe(value => {
      if (value instanceof NavigationEnd) {
        this.url = value.url;
        this.updateActiveNavigationItem();
      }
    });
    this.breakpointObserver.observe(['(max-width: 767px)']).pipe(takeUntilDestroyed(this.destroyed)).subscribe(state => {
      this.mobileView = state.breakpoints['(max-width: 767px)'];
    });
    this.headerUtilService.mobileSidebarOpen.pipe(takeUntilDestroyed(this.destroyed)).subscribe(value => {
      this.mobileViewOpen = value;
    });
  }
  openSlimSubmenu(node) {
    if (this.openedSlimSubmenuNode === node) {
      this.openedSlimSubmenuNode = undefined;
    } else {
      this.openedSlimSubmenuNode = node.children && node.children.length > 0 ? node : undefined;
    }
  }
  onNodeSelected(node) {
    if (node.data?.customAction) {
      this.customActionTriggered.emit(node.data.customAction);
      this.selectedNode = node;
      return;
    }
    if (this.slimView && !this.mobileView && node.children?.length) {
      // If slim mode, open submenu for this node
      this.openedSlimSubmenuNode = node;
      this.selectedNode = node;
    } else {
      // If the node has a route, navigate
      this.selectedNode = node;
      if (node.data?.route) {
        void this.onNavigationItemClicked(node);
      }
    }
  }
  onSlimChildClick(child, event) {
    event.stopPropagation();
    // If the clicked child is already active, do nothing.
    if (child === this.activeRouteNode) {
      // This prevents re-navigation and losing the highlighted state.
      return;
    }
    if (child.data?.disabled) return;
    // Navigate as before if it's a different node.
    void this.onNavigationItemClicked(child);
    this.openedSlimSubmenuNode = undefined;
  }
  toggleSlimView() {
    this.slimView = !this.slimView;
    if (this.slimView) {
      this.openedSlimSubmenuNode = undefined;
      this.collapseAllNodes(this._navigationItems);
      this.collapseAllNodes(this._adminViewNavigationItems);
    }
    // Re-run the selection logic so we highlight correctly based on the current mode
    this.updateActiveNavigationItem();
  }
  mapNavigationItems(navItems) {
    return navItems.map(navItem => ({
      icon: navItem.icon,
      iconBaseUrl: navItem.iconBaseUrl,
      iconAppKey: navItem.iconAppKey,
      expanded: navItem.expanded,
      // Only selectable if it has a route and not disabled
      selectable: !!navItem.route && !navItem.disabled,
      label: navItem.label,
      data: {
        route: navItem.route,
        disabled: navItem.disabled,
        customAction: navItem.customAction
      },
      children: navItem.children?.map(childItem => ({
        icon: childItem.icon,
        expanded: childItem.expanded,
        // Only selectable if the child has a route and not disabled
        selectable: !!childItem.route && !childItem.disabled,
        label: childItem.label,
        data: {
          route: childItem.route,
          disabled: childItem.disabled
        }
      }))
    }));
  }
  viewChanged(event) {
    if (event.value === 'ADMIN_VIEW') {
      void this.onNavigationItemClicked(this._adminViewNavigationItems[0]).then(success => {
        if (success) {
          this.isAdminViewActive = true;
        } else {
          this.selectedView = 'DEFAULT_VIEW';
        }
      });
    } else {
      void this.onNavigationItemClicked(this._navigationItems[0]).then(success => {
        if (success) {
          this.isAdminViewActive = false;
        } else {
          this.selectedView = 'ADMIN_VIEW';
        }
      });
    }
  }
  updateActiveNavigationItem() {
    if (!this.url) {
      this.url = this.router.url;
    }
    const result = this.findNodeByUrl();
    if (result?.matchedNode) {
      this.activeRouteNode = result.matchedNode;
      // If slim mode, highlight the parent node's icon
      // Otherwise, highlight the found node itself
      const highlightParent = this.slimView && !this.mobileView && result?.parentNode;
      this.selectedNode = highlightParent ? result?.parentNode : result.matchedNode;
      this.selectedView = this.isAdminViewActive ? 'ADMIN_VIEW' : 'DEFAULT_VIEW';
    }
  }
  findNodeByUrl() {
    for (const item of this._navigationItems) {
      if (this.url === item.data?.route) {
        this.isAdminViewActive = false;
        return {
          matchedNode: item
        };
      } else if (item.children) {
        const childNode = this.findNodeInChildren(item, false);
        if (childNode) return childNode;
      }
    }
    for (const item of this._adminViewNavigationItems) {
      if (this.url === item.data?.route) {
        this.isAdminViewActive = true;
        return {
          matchedNode: item
        };
      } else if (item.children) {
        const childNode = this.findNodeInChildren(item, true);
        if (childNode) return childNode;
      }
    }
    return {};
  }
  findNodeInChildren(item, isAdminViewActive) {
    for (const childItem of item.children ?? []) {
      if (childItem.data?.route === this.url) {
        this.isAdminViewActive = isAdminViewActive;
        return {
          matchedNode: childItem,
          parentNode: item
        };
      }
    }
    return undefined;
  }
  checkContactFormSidePanelConfig(bottomItems) {
    const contactBarSidepanel = bottomItems.find(item => item.type === SidepanelTypes.CONTACT);
    if (contactBarSidepanel) {
      if (contactBarSidepanel.requestType) {
        this.contactFormService.setContactFormRequestType = contactBarSidepanel.requestType;
      }
      if (contactBarSidepanel.supportAppBaseUrl) {
        this.contactFormService.setSupportAppBaseUrl = contactBarSidepanel.supportAppBaseUrl;
      } else {
        // Show Error if Support App Base URL is missing to ensure contact form functionality
        // eslint-disable-next-line no-console
        console.error(this.SUPPORT_APP_URL_MISSING);
      }
    }
  }
  onNavigationItemClicked(event) {
    const route = event?.data?.route;
    if (!route) {
      return Promise.resolve(false);
    }
    this.selectedNode = event;
    this.selectedTemplate = undefined;
    this.headerUtilService.mobileSidebarOpen.next(false);
    return this.navigateTo(route);
  }
  onNodeDeselected(node) {
    this.selectedNode = undefined;
    // the primeNG tree component does not allow disabling deselection of nodes. This is a workaround to reset the original node after an attempted deselect.
    return setTimeout(() => {
      this.selectedNode = node;
      void this.navigateTo(node.data?.route ?? '/dashboard');
    }, 1);
  }
  onNodeClicked(node, event) {
    // In slim mode, clicking on a parent node with children and no direct route
    if (this.slimView && !this.mobileView && node.children?.length && !node.data?.route) {
      event.stopPropagation();
      // If a different submenu is currently open, close it by assigning the new one
      if (this.openedSlimSubmenuNode !== node) {
        this.openedSlimSubmenuNode = node;
      }
      // If the same submenu node is clicked again, do nothing (leave it open).
    }
  }
  onBottomClick(panel) {
    this.isErrorForm = false;
    this.contactFormService.closeContactForm();
    this.selectedTemplate = undefined;
    if (!panel) {
      return;
    }
    if (Array.isArray(panel)) {
      return;
    }
    this.changeDect.detectChanges();
    if (!panel.data?.type) {
      throw new Error('panel lacks data type implementation');
    }
    switch (panel.data.type) {
      case SidepanelTypes.ROUTER:
        this.router.navigateByUrl(panel.data.router.url).catch(error => {
          throw error;
        });
        this.headerUtilService.mobileSidebarOpen.next(false);
        break;
      case SidepanelTypes.CONTACT:
        this.contactFormService.showContactForm();
        this.selectedBottomNode = undefined;
        this.headerUtilService.mobileSidebarOpen.next(false);
        break;
      case SidepanelTypes.CARD:
        this.complexDialogV3Service.open({
          hideButtons: true,
          header: 'Version'
        }, VersionModalComponent);
        this.selectedBottomNode = undefined;
        this.headerUtilService.mobileSidebarOpen.next(false);
        break;
      case SidepanelTypes.FOOTER:
        this.complexDialogService.open({
          data: panel.data.inputs,
          title: 'NAV-BAR.ABOUT',
          hideButtons: true
        }, panel.data.ref);
        this.selectedBottomNode = undefined;
        this.headerUtilService.mobileSidebarOpen.next(false);
        break;
      default:
        break;
    }
  }
  openSwitchViewDropdown() {
    this.changeViewDropdown.show();
  }
  navigateTo(route) {
    return this.router.navigateByUrl(route);
  }
  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
  }
  getTemplateSidePanel() {
    if (!this.selectedTemplate) return null;
    if (Array.isArray(this.selectedTemplate)) return null;
    if (this.selectedTemplate?.data?.type !== SidepanelTypes.TEMPLATE && this.selectedTemplate?.data?.type !== SidepanelTypes.FOOTER) return null;
    return this.selectedTemplate.data;
  }
  collapseAllNodes(nodes) {
    for (const node of nodes) {
      node.expanded = false;
      if (node.children) {
        this.collapseAllNodes(node.children);
      }
    }
  }
  onClickOutside(target) {
    const insideSidebar = target.closest('.sidebar') !== null;
    const insideSubmenu = target.closest('.slim-submenu-container') !== null;
    if (this.slimView && !this.mobileView && this.openedSlimSubmenuNode) {
      // Close submenu if:
      // 1. Click is outside the sidebar (insideSidebar = false), or
      // 2. Click is inside the sidebar but not inside the submenu (insideSubmenu = false)
      if (!insideSidebar || insideSidebar && !insideSubmenu) {
        this.openedSlimSubmenuNode = undefined;
      }
    }
  }
  static ɵfac = function SidebarV2Component_Factory(t) {
    return new (t || SidebarV2Component)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.DialogV2Service), i0.ɵɵdirectiveInject(i0.DestroyRef), i0.ɵɵdirectiveInject(i3.BreakpointObserver), i0.ɵɵdirectiveInject(i4.HeaderUtilService), i0.ɵɵdirectiveInject(i2.ComplexDialogV2Service), i0.ɵɵdirectiveInject(i2.ComplexDialogV3Service), i0.ɵɵdirectiveInject(i5.ContactFormService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SidebarV2Component,
    selectors: [["geaui-sidebar-v2"]],
    viewQuery: function SidebarV2Component_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.changeViewDropdown = _t.first);
      }
    },
    hostBindings: function SidebarV2Component_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function SidebarV2Component_click_HostBindingHandler($event) {
          return ctx.onClickOutside($event.target);
        }, false, i0.ɵɵresolveDocument);
      }
    },
    inputs: {
      devisionIconPath: "devisionIconPath",
      devisionIconBackgroundColor: "devisionIconBackgroundColor",
      devisionName: "devisionName",
      loading: "loading",
      navigationItems: "navigationItems",
      adminViewNavigationItems: "adminViewNavigationItems",
      hasSearch: "hasSearch",
      slimView: "slimView",
      bottomNavigation: "bottomNavigation"
    },
    outputs: {
      customActionTriggered: "customActionTriggered"
    },
    decls: 2,
    vars: 2,
    consts: [["sidebar", ""], ["changeViewDropdown", ""], ["class", "sidebar-full-page", 3, "ngClass", 4, "ngIf"], [1, "sidepanel", 3, "ngClass"], [1, "sidebar-full-page", 3, "ngClass"], [1, "sidebar", 3, "ngClass"], ["class", "sidebar-toggle-icon", 3, "click", 4, "ngIf"], [1, "title-bar"], [1, "devision-icon-container"], ["class", "devision-icon", 3, "src", "svgAriaLabel", 4, "ngIf"], ["count", "1", "appearance", "line", 3, "theme", 4, "ngIf"], ["class", "title-text", 4, "ngIf"], ["class", "dropdown-icon-container", 4, "ngIf"], ["class", "sidebar-dropdown", 3, "ngModel", "ngClass", "options", "panelStyleClass", "appendTo", "ngModelChange", "onChange", 4, "ngIf"], ["class", "search-bar", 3, "showBottomBorderOnly", "hasProminentButton", "placeholder", 4, "ngIf"], ["class", "search-icon", "file", "16px_search", 3, "click", 4, "ngIf"], ["class", "search-divider", 4, "ngIf"], [1, "tree-container", "scrollable", 3, "ngClass"], ["selectionMode", "single", 1, "nav-tree", 3, "onNodeSelect", "onNodeUnselect", "selection", "value", "metaKeySelection"], ["pTemplate", "default"], [1, "tree-container", "bottom-navigation", 3, "ngClass"], [1, "sidebar-toggle-icon", 3, "click"], ["color", "white", 3, "file"], [1, "devision-icon", 3, "src", "svgAriaLabel"], ["count", "1", "appearance", "line", 3, "theme"], [1, "title-text"], [1, "dropdown-icon-container"], [1, "sidebar-dropdown", 3, "click", "pTooltip"], ["file", "16px_sort", "color", "black"], [1, "sidebar-dropdown", 3, "ngModelChange", "onChange", "ngModel", "ngClass", "options", "panelStyleClass", "appendTo"], [1, "search-bar", 3, "showBottomBorderOnly", "hasProminentButton", "placeholder"], ["file", "16px_search", 1, "search-icon", 3, "click"], [1, "search-divider"], ["data-cy", "sidebar-node", 1, "tree-node", 3, "click", "ngClass"], ["tooltipPosition", "right", 1, "nav-item-name", 3, "pTooltip"], [3, "fileSize", "file", "color", "baseUrl", "appKey", 4, "ngIf"], ["class", "node-label node-ellipsis", "geauiTooltipOnEllipsisV2", "", 3, "ngClass", "pTooltip", "click", 4, "ngIf"], ["class", "node-label", 4, "ngIf"], ["class", "toggle-icon", 3, "file", "color", "click", 4, "ngIf"], ["class", "toggle-icon", "count", "1", "appearance", "line", 3, "theme", 4, "ngIf"], ["class", "slim-submenu-container", 4, "ngIf"], [3, "fileSize", "file", "color", "baseUrl", "appKey"], ["geauiTooltipOnEllipsisV2", "", 1, "node-label", "node-ellipsis", 3, "click", "ngClass", "pTooltip"], [1, "node-label"], [1, "toggle-icon", 3, "click", "file", "color"], ["count", "1", "appearance", "line", 1, "toggle-icon", 3, "theme"], [1, "slim-submenu-container"], [1, "slim-submenu"], [1, "submenu-header"], ["tooltipPosition", "right", 3, "ngClass", "pTooltip", "click", 4, "ngFor", "ngForOf"], ["tooltipPosition", "right", 3, "click", "ngClass", "pTooltip"], [1, "node-label", "node-ellipsis", 3, "ngClass"], ["type", "solid"], ["selectionMode", "single", 3, "selectionChange", "selection", "metaKeySelection", "value"], ["data-cy", "sidebar-node", 1, "tree-node", 3, "ngClass"], [1, "nav-item-name"], [3, "fileSize", "file", "baseUrl", "appKey", "color", "pTooltip", 4, "ngIf"], ["class", "node-label", 3, "ngClass", "dblclick", 4, "ngIf"], [3, "fileSize", "file", "baseUrl", "appKey", "color", "pTooltip"], [1, "node-label", 3, "dblclick", "ngClass"], [1, "close-container"], [4, "ngComponentOutlet", "ngComponentOutletInputs"], ["file", "16px_close", "color", "black", 3, "click", "clickable"]],
    template: function SidebarV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, SidebarV2Component_div_0_Template, 19, 25, "div", 2)(1, SidebarV2Component_Conditional_1_Template, 3, 8, "div", 3);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.mobileView || ctx.mobileViewOpen);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.getTemplateSidePanel() ? 1 : -1);
      }
    },
    dependencies: [i6.NgClass, i6.NgComponentOutlet, i6.NgForOf, i6.NgIf, i7.SvgIconComponent, i8.Divider, i9.Tree, i10.PrimeTemplate, i11.IconV3Component, i12.SearchBarV2Component, i13.Tooltip, i14.Dropdown, i15.NgControlStatus, i15.NgModel, i16.TooltipOnEllipsisV2Directive, i17.NgxSkeletonLoaderComponent, i18.TranslatePipe],
    styles: [".sidebar[_ngcontent-%COMP%]{background-color:var(--geaui-grey-06);border-right:1px solid var(--geaui-grey-03);width:258px;height:100%;display:flex;flex-direction:column;align-items:center;padding:24px 0;overflow:hidden;z-index:5}.sidebar[_ngcontent-%COMP%]:hover{overflow-y:auto}.sidebar[_ngcontent-%COMP%]   .sidebar-dropdown[_ngcontent-%COMP%]{padding:24px;width:100%}.sidebar[_ngcontent-%COMP%]   .sidebar-toggle-icon[_ngcontent-%COMP%]{background-color:var(--geaui-primary);position:fixed;left:258px;transform:translate(-50%);width:32px;height:32px;align-items:center;justify-content:center;border-radius:50px;top:100px;cursor:pointer;display:none;z-index:5}.sidebar[_ngcontent-%COMP%]:hover   .sidebar-toggle-icon[_ngcontent-%COMP%]{display:flex}.sidebar[_ngcontent-%COMP%]   .title-bar[_ngcontent-%COMP%]{display:flex;width:100%;flex-direction:row;padding:12px 24px;align-items:center}.sidebar[_ngcontent-%COMP%]   .title-bar[_ngcontent-%COMP%]   .devision-icon-container[_ngcontent-%COMP%]{display:flex;width:40px;height:40px;align-items:center;justify-content:center;border-radius:8px}.sidebar[_ngcontent-%COMP%]   .title-bar[_ngcontent-%COMP%]   .devision-icon-container[_ngcontent-%COMP%]   .devision-icon[_ngcontent-%COMP%]{width:24px;height:24px}.sidebar[_ngcontent-%COMP%]   .title-bar[_ngcontent-%COMP%]   .devision-icon-container[_ngcontent-%COMP%]   .devision-icon[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--geaui-white)}.sidebar[_ngcontent-%COMP%]   .title-bar[_ngcontent-%COMP%]   .title-text[_ngcontent-%COMP%]{font-size:14px;font-weight:600;line-height:120%;margin-left:16px}.sidebar[_ngcontent-%COMP%]   .search-bar[_ngcontent-%COMP%]{display:block;width:100%;padding:12px 24px}.sidebar[_ngcontent-%COMP%]   .search-divider[_ngcontent-%COMP%]{width:100%;padding:16px}.sidebar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]{width:100%}.sidebar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]   .p-tree[_ngcontent-%COMP%]{background:transparent}.sidebar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]   .tree-node[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;padding:16px 28px}.sidebar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]   .tree-node[_ngcontent-%COMP%]   .nav-item-name[_ngcontent-%COMP%]{display:flex;align-items:center;height:24px}.sidebar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]   .tree-node[_ngcontent-%COMP%]   .nav-item-name[_ngcontent-%COMP%]   .node-label[_ngcontent-%COMP%]{margin-left:8px;font-size:16px;font-weight:500;line-height:130%}.sidebar.slim-bar[_ngcontent-%COMP%]{width:73px;padding:24px 0;overflow:visible}.sidebar.slim-bar[_ngcontent-%COMP%]   .dropdown-icon-container[_ngcontent-%COMP%]{padding:24px 16px;width:100%}.sidebar.slim-bar[_ngcontent-%COMP%]   .dropdown-icon-container[_ngcontent-%COMP%]   .sidebar-dropdown[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;padding:16px 12px;background:var(--geaui-grey-04);border-radius:8px;height:49px}.sidebar.slim-bar[_ngcontent-%COMP%]   .dropdown-icon-container[_ngcontent-%COMP%]   .sidebar-dropdown[_ngcontent-%COMP%]:hover{cursor:pointer;background:var(--geaui-vibrant-blue-190)}.sidebar.slim-bar[_ngcontent-%COMP%]   .sidebar-toggle-icon[_ngcontent-%COMP%]{left:73px;transform:translate(-50%);z-index:5}.sidebar.slim-bar[_ngcontent-%COMP%]   .title-bar[_ngcontent-%COMP%]{padding:12px 16px}.sidebar.slim-bar[_ngcontent-%COMP%]   .search-icon[_ngcontent-%COMP%]{cursor:pointer;padding:28px}.sidebar.slim-bar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]   .tree-node[_ngcontent-%COMP%]{position:relative;display:flex;justify-content:center;align-items:center;padding:16px 28px}.sidebar.slim-bar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]   .tree-node[_ngcontent-%COMP%]   .nav-item-name[_ngcontent-%COMP%]{justify-content:center}.sidebar.slim-bar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]   .tree-node[_ngcontent-%COMP%]   .slim-submenu-container[_ngcontent-%COMP%]{position:absolute;color:var(--geaui-primary-black);top:0;left:100%;background:var(--geaui-grey-06);z-index:999}.sidebar.slim-bar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]   .tree-node[_ngcontent-%COMP%]   .slim-submenu-container[_ngcontent-%COMP%]   .submenu-header[_ngcontent-%COMP%]{display:flex;align-items:center;padding:18px 24px;cursor:default}.sidebar.slim-bar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]   .tree-node[_ngcontent-%COMP%]   .slim-submenu-container[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style:none;margin:0;padding-left:0}.sidebar.slim-bar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]   .tree-node[_ngcontent-%COMP%]   .slim-submenu-container[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:flex;align-items:center;padding:18px 24px 18px 40px;cursor:pointer}.sidebar.slim-bar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]   .tree-node[_ngcontent-%COMP%]   .slim-submenu-container[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%]{color:gray;cursor:default!important}.sidebar.slim-bar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]   .tree-node[_ngcontent-%COMP%]   .slim-submenu-container[_ngcontent-%COMP%]   li.selected[_ngcontent-%COMP%]{background-color:var(--geaui-grey-03);color:var(--geaui-vibrant-blue)}.sidebar.slim-bar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]   .tree-node[_ngcontent-%COMP%]   .slim-submenu-container[_ngcontent-%COMP%]   .slim-submenu[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{display:flex;align-items:center}.sidebar.slim-bar[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]   .tree-node[_ngcontent-%COMP%]   .node-label[_ngcontent-%COMP%]{margin-left:8px;font-size:16px;font-weight:500;line-height:130%}.sidepanel[_ngcontent-%COMP%]{position:absolute;background-color:#fff;top:60px;width:100%;height:calc(100vh - 60px);transition:left .5s,width .5s;padding:17px;z-index:3}.sidepanel.full[_ngcontent-%COMP%]{left:258px;width:calc(100% - 258px);transition:left .5s,width .5s}.sidepanel.slim[_ngcontent-%COMP%]{left:73px;width:calc(100% - 73px);transition:left .5s,width .5s}.sidepanel.mobile[_ngcontent-%COMP%]{left:0;width:100%;transition:left .5s,width .5s}.sidepanel[_ngcontent-%COMP%]   .close-container[_ngcontent-%COMP%]{width:100%;padding-bottom:10px;padding-right:12px;display:flex;justify-content:flex-end}.sidepanel[_ngcontent-%COMP%]   .close-container[_ngcontent-%COMP%]   geaui-icon-v2[_ngcontent-%COMP%]{cursor:pointer}.sidebar-full-page[_ngcontent-%COMP%]{display:flex;flex-direction:row;width:100%;height:100%;position:relative}.mobile-view-open[_ngcontent-%COMP%]   .sidebar[_ngcontent-%COMP%]{width:100vw}.mobile-view-open[_ngcontent-%COMP%]   .tree-container[_ngcontent-%COMP%]{padding-top:4px}.mobile-view-open.sidebar-full-page[_ngcontent-%COMP%]{position:absolute;height:calc(100vh - 60px)}.tree-node.disabled[_ngcontent-%COMP%]   .nav-item-name[_ngcontent-%COMP%]   .geaui-icon-v2[_ngcontent-%COMP%], .tree-node.disabled[_ngcontent-%COMP%]   .nav-item-name[_ngcontent-%COMP%]   .node-label[_ngcontent-%COMP%]{color:gray;pointer-events:none}.tree-node[_ngcontent-%COMP%]:not(.disabled){cursor:pointer}.slim-submenu[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{display:flex;align-items:center}.node-ellipsis[_ngcontent-%COMP%]{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;overflow:hidden;width:170px;overflow-wrap:break-word;-moz-hyphens:auto}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-sidebar-v2',
      template: "<div\n  class=\"sidebar-full-page\"\n  #sidebar\n  *ngIf=\"!mobileView || mobileViewOpen\"\n  [ngClass]=\"{ 'mobile-view-open': mobileView && mobileViewOpen }\">\n  <div class=\"sidebar\" [ngClass]=\"{ 'slim-bar': slimView && !mobileView }\">\n    <div class=\"sidebar-toggle-icon\" *ngIf=\"!mobileView\" (click)=\"toggleSlimView()\">\n      <geaui-icon-v3 [file]=\"slimView ? '16px_chevron-right' : '16px_chevron-left'\" color=\"white\"></geaui-icon-v3>\n    </div>\n    <div class=\"title-bar\">\n      <div class=\"devision-icon-container\" [style.backgroundColor]=\"loading ? '' : devisionIconBackgroundColor\">\n        <svg-icon\n          class=\"devision-icon\"\n          *ngIf=\"!loading\"\n          [src]=\"devisionIconPath\"\n          [svgAriaLabel]=\"devisionName + ' icon'\"></svg-icon>\n        <ngx-skeleton-loader\n          *ngIf=\"loading\"\n          [theme]=\"{ height: '40px', width: '40px', 'margin-bottom': 0 }\"\n          count=\"1\"\n          appearance=\"line\"></ngx-skeleton-loader>\n      </div>\n      <span class=\"title-text\" *ngIf=\"(!slimView || mobileView) && !loading\">{{ devisionName }}</span>\n      <span class=\"title-text\" *ngIf=\"(!slimView || mobileView) && loading\">\n        <ngx-skeleton-loader\n          [theme]=\"{ height: '24px', width: '107px', 'margin-bottom': 0 }\"\n          count=\"1\"\n          appearance=\"line\"></ngx-skeleton-loader>\n      </span>\n    </div>\n    <div class=\"dropdown-icon-container\" *ngIf=\"slimView && _adminViewNavigationItems.length > 0\">\n      <div class=\"sidebar-dropdown\" [pTooltip]=\"'UI.LIB.SIDEBAR.SWITCH-VIEW' | translate\" (click)=\"openSwitchViewDropdown()\">\n        <geaui-icon-v3 file=\"16px_sort\" color=\"black\"></geaui-icon-v3>\n      </div>\n    </div>\n\n    <p-dropdown\n      class=\"sidebar-dropdown\"\n      #changeViewDropdown\n      *ngIf=\"_adminViewNavigationItems.length > 0\"\n      [(ngModel)]=\"selectedView\"\n      [ngClass]=\"{ hide: slimView && _adminViewNavigationItems }\"\n      [options]=\"sidebarViewOptions\"\n      [panelStyleClass]=\"slimView ? 'slim-view' : 'normal-view'\"\n      [appendTo]=\"slimView ? sidebar : null\"\n      (onChange)=\"viewChanged($event)\">\n    </p-dropdown>\n\n    <geaui-search-bar-v2\n      class=\"search-bar\"\n      *ngIf=\"hasSearch && (!slimView || mobileView)\"\n      [showBottomBorderOnly]=\"true\"\n      [hasProminentButton]=\"false\"\n      [placeholder]=\"'Search'\">\n    </geaui-search-bar-v2>\n    <geaui-icon-v3 class=\"search-icon\" *ngIf=\"hasSearch && slimView && !mobileView\" (click)=\"slimView = false\" file=\"16px_search\">\n    </geaui-icon-v3>\n    <p-divider class=\"search-divider\" *ngIf=\"hasSearch\"></p-divider>\n\n    <div class=\"tree-container scrollable\" [ngClass]=\"{ 'no-search': !hasSearch }\">\n      <p-tree\n        class=\"nav-tree\"\n        [selection]=\"selectedNode\"\n        [value]=\"\n          isAdminViewActive\n            ? slimView && !mobileView\n              ? adminViewFlatItems\n              : _adminViewNavigationItems\n            : slimView && !mobileView\n              ? flatItems\n              : _navigationItems\n        \"\n        [metaKeySelection]=\"false\"\n        (onNodeSelect)=\"onNodeSelected($event.node)\"\n        (onNodeUnselect)=\"onNodeDeselected($event.node)\"\n        selectionMode=\"single\">\n        <ng-template let-node pTemplate=\"default\">\n          <div\n            class=\"tree-node\"\n            [ngClass]=\"{ selected: node === selectedNode, disabled: node.data?.disabled }\"\n            [attr.data-label]=\"node.label | translate\"\n            (click)=\"onNodeClicked(node, $event)\"\n            data-cy=\"sidebar-node\">\n            <div\n              class=\"nav-item-name\"\n              [pTooltip]=\"\n                node.data?.disabled ? ('X.INFO.NO_ACCESS.RIGHT_MISSING' | translate) : slimView ? (node.label | translate) : ''\n              \"\n              tooltipPosition=\"right\">\n              <geaui-icon-v3\n                *ngIf=\"!loading\"\n                [fileSize]=\"16\"\n                [file]=\"node.icon\"\n                [color]=\"node === selectedNode ? 'blue' : node.data?.disabled ? 'grey' : 'black'\"\n                [baseUrl]=\"node.iconBaseUrl\"\n                [appKey]=\"node.iconAppKey\">\n              </geaui-icon-v3>\n              <ngx-skeleton-loader\n                *ngIf=\"loading\"\n                [theme]=\"{ height: '24px', width: '24px', 'margin-bottom': 0 }\"\n                count=\"1\"\n                appearance=\"line\"></ngx-skeleton-loader>\n              <span\n                class=\"node-label node-ellipsis\"\n                *ngIf=\"(!slimView || mobileView) && !loading\"\n                [ngClass]=\"{ selected: node === selectedNode, disabled: node.data?.disabled }\"\n                [pTooltip]=\"node.label | translate\"\n                (click)=\"node.expanded = !node.expanded\"\n                geauiTooltipOnEllipsisV2>\n                {{ node.label | translate }}\n              </span>\n              <span class=\"node-label\" *ngIf=\"(!slimView || mobileView) && loading\">\n                <ngx-skeleton-loader\n                  [theme]=\"{ height: '24px', width: '107px', 'margin-bottom': 0 }\"\n                  count=\"1\"\n                  appearance=\"line\"></ngx-skeleton-loader>\n              </span>\n            </div>\n\n            <!-- Toggle icon visible only in expanded or mobile mode -->\n            <geaui-icon-v3\n              class=\"toggle-icon\"\n              *ngIf=\"node.children && (!slimView || mobileView) && !loading\"\n              [file]=\"node.expanded ? '16px_chevron-up' : '16px_chevron-down'\"\n              [color]=\"node === selectedNode ? 'blue' : node.data?.disabled ? 'grey' : 'black'\"\n              (click)=\"node.expanded = !node.expanded; $event.stopPropagation()\">\n            </geaui-icon-v3>\n            <ngx-skeleton-loader\n              class=\"toggle-icon\"\n              *ngIf=\"node.children && (!slimView || mobileView) && loading\"\n              [theme]=\"{ height: '24px', width: '24px', 'margin-bottom': 0 }\"\n              count=\"1\"\n              appearance=\"line\"></ngx-skeleton-loader>\n\n            <!-- Slim submenu for children -->\n            <div\n              class=\"slim-submenu-container\"\n              *ngIf=\"slimView && !mobileView && openedSlimSubmenuNode === node && node.children?.length\">\n              <div class=\"slim-submenu\">\n                <div class=\"submenu-header\">\n                  <geaui-icon-v3\n                    [fileSize]=\"16\"\n                    [file]=\"node.icon\"\n                    [color]=\"'black'\"\n                    [baseUrl]=\"node.iconBaseUrl\"\n                    [appKey]=\"node.iconAppKey\"></geaui-icon-v3>\n                  <span class=\"node-label\">{{ node.label | translate }}</span>\n                </div>\n                <ul>\n                  <li\n                    *ngFor=\"let child of node.children\"\n                    [ngClass]=\"{ selected: child === activeRouteNode, disabled: child.data?.disabled }\"\n                    [pTooltip]=\"child.data?.disabled ? ('X.INFO.NO_ACCESS.RIGHT_MISSING' | translate) : (child.label | translate)\"\n                    (click)=\"onSlimChildClick(child, $event)\"\n                    tooltipPosition=\"right\">\n                    <geaui-icon-v3\n                      [fileSize]=\"16\"\n                      [file]=\"child.icon\"\n                      [color]=\"child === activeRouteNode ? 'blue' : child.data?.disabled ? 'grey' : 'black'\"\n                      [baseUrl]=\"child.iconBaseUrl\"\n                      [appKey]=\"child.iconAppKey\">\n                    </geaui-icon-v3>\n                    <span\n                      class=\"node-label node-ellipsis\"\n                      [ngClass]=\"{ selected: child === activeRouteNode, disabled: child.data?.disabled }\"\n                      >{{ child.label | translate }}</span\n                    >\n                  </li>\n                </ul>\n              </div>\n            </div>\n          </div>\n        </ng-template>\n      </p-tree>\n    </div>\n\n    @if (_bottomNavigation.length) {\n      <div class=\"tree-container bottom-navigation\" [ngClass]=\"{ 'no-search': !hasSearch }\">\n        <p-divider type=\"solid\"></p-divider>\n        <p-tree\n          [(selection)]=\"selectedBottomNode\"\n          [metaKeySelection]=\"false\"\n          [value]=\"slimView && !mobileView ? flatBottomNavigation : _bottomNavigation\"\n          (selectionChange)=\"onBottomClick($event)\"\n          selectionMode=\"single\">\n          <ng-template let-node pTemplate=\"default\">\n            <div\n              class=\"tree-node\"\n              [ngClass]=\"{ selected: node === selectedNode }\"\n              [attr.data-label]=\"node.label | translate\"\n              data-cy=\"sidebar-node\">\n              <div class=\"nav-item-name\">\n                <geaui-icon-v3\n                  *ngIf=\"!loading\"\n                  [fileSize]=\"16\"\n                  [file]=\"node.icon\"\n                  [baseUrl]=\"node.iconBaseUrl\"\n                  [appKey]=\"node.iconAppKey\"\n                  [color]=\"node === selectedNode ? 'blue' : 'black'\"\n                  [pTooltip]=\"(slimView && !mobileView ? node.label : '') | translate\">\n                </geaui-icon-v3>\n                <ngx-skeleton-loader\n                  *ngIf=\"loading\"\n                  [theme]=\"{ height: '24px', width: '24px', 'margin-bottom': 0 }\"\n                  count=\"1\"\n                  appearance=\"line\"></ngx-skeleton-loader>\n                <span\n                  class=\"node-label\"\n                  *ngIf=\"(!slimView || mobileView) && !loading\"\n                  [ngClass]=\"{ selected: node === selectedNode }\"\n                  (dblclick)=\"node.expanded = !node.expanded; $event.stopPropagation()\">\n                  {{ node.label | translate }}\n                </span>\n                <span class=\"node-label\" *ngIf=\"(!slimView || mobileView) && loading\">\n                  <ngx-skeleton-loader\n                    [theme]=\"{ height: '24px', width: '107px', 'margin-bottom': 0 }\"\n                    count=\"1\"\n                    appearance=\"line\"></ngx-skeleton-loader>\n                </span>\n              </div>\n              <geaui-icon-v3\n                class=\"toggle-icon\"\n                *ngIf=\"node.children && (!slimView || mobileView) && !loading\"\n                [file]=\"node.expanded ? '16px_chevron-up' : '16px_chevron-down'\"\n                [color]=\"node === selectedNode ? 'blue' : 'black'\"\n                (click)=\"node.expanded = !node.expanded; $event.stopPropagation()\">\n              </geaui-icon-v3>\n              <ngx-skeleton-loader\n                *ngIf=\"node.children && (!slimView || mobileView) && loading\"\n                [theme]=\"{ height: '24px', width: '24px', 'margin-bottom': 0 }\"\n                count=\"1\"\n                appearance=\"line\"></ngx-skeleton-loader>\n            </div>\n          </ng-template>\n        </p-tree>\n      </div>\n    }\n  </div>\n</div>\n@if (getTemplateSidePanel()) {\n  <div class=\"sidepanel\" [ngClass]=\"{ full: !slimView, slim: slimView, mobile: mobileView }\">\n    @if (getTemplateSidePanel()!.closeable !== false) {\n      <div class=\"close-container\">\n        <geaui-icon-v3 [clickable]=\"true\" (click)=\"selectedTemplate = undefined\" file=\"16px_close\" color=\"black\"></geaui-icon-v3>\n      </div>\n    }\n    <ng-container *ngComponentOutlet=\"getTemplateSidePanel()!.ref; inputs: getTemplateSidePanel()!.inputs\"></ng-container>\n  </div>\n}\n",
      styles: [".sidebar{background-color:var(--geaui-grey-06);border-right:1px solid var(--geaui-grey-03);width:258px;height:100%;display:flex;flex-direction:column;align-items:center;padding:24px 0;overflow:hidden;z-index:5}.sidebar:hover{overflow-y:auto}.sidebar .sidebar-dropdown{padding:24px;width:100%}.sidebar .sidebar-toggle-icon{background-color:var(--geaui-primary);position:fixed;left:258px;transform:translate(-50%);width:32px;height:32px;align-items:center;justify-content:center;border-radius:50px;top:100px;cursor:pointer;display:none;z-index:5}.sidebar:hover .sidebar-toggle-icon{display:flex}.sidebar .title-bar{display:flex;width:100%;flex-direction:row;padding:12px 24px;align-items:center}.sidebar .title-bar .devision-icon-container{display:flex;width:40px;height:40px;align-items:center;justify-content:center;border-radius:8px}.sidebar .title-bar .devision-icon-container .devision-icon{width:24px;height:24px}.sidebar .title-bar .devision-icon-container .devision-icon path{fill:var(--geaui-white)}.sidebar .title-bar .title-text{font-size:14px;font-weight:600;line-height:120%;margin-left:16px}.sidebar .search-bar{display:block;width:100%;padding:12px 24px}.sidebar .search-divider{width:100%;padding:16px}.sidebar .tree-container{width:100%}.sidebar .tree-container .p-tree{background:transparent}.sidebar .tree-container .tree-node{display:flex;justify-content:space-between;align-items:center;padding:16px 28px}.sidebar .tree-container .tree-node .nav-item-name{display:flex;align-items:center;height:24px}.sidebar .tree-container .tree-node .nav-item-name .node-label{margin-left:8px;font-size:16px;font-weight:500;line-height:130%}.sidebar.slim-bar{width:73px;padding:24px 0;overflow:visible}.sidebar.slim-bar .dropdown-icon-container{padding:24px 16px;width:100%}.sidebar.slim-bar .dropdown-icon-container .sidebar-dropdown{display:flex;align-items:center;justify-content:center;padding:16px 12px;background:var(--geaui-grey-04);border-radius:8px;height:49px}.sidebar.slim-bar .dropdown-icon-container .sidebar-dropdown:hover{cursor:pointer;background:var(--geaui-vibrant-blue-190)}.sidebar.slim-bar .sidebar-toggle-icon{left:73px;transform:translate(-50%);z-index:5}.sidebar.slim-bar .title-bar{padding:12px 16px}.sidebar.slim-bar .search-icon{cursor:pointer;padding:28px}.sidebar.slim-bar .tree-container .tree-node{position:relative;display:flex;justify-content:center;align-items:center;padding:16px 28px}.sidebar.slim-bar .tree-container .tree-node .nav-item-name{justify-content:center}.sidebar.slim-bar .tree-container .tree-node .slim-submenu-container{position:absolute;color:var(--geaui-primary-black);top:0;left:100%;background:var(--geaui-grey-06);z-index:999}.sidebar.slim-bar .tree-container .tree-node .slim-submenu-container .submenu-header{display:flex;align-items:center;padding:18px 24px;cursor:default}.sidebar.slim-bar .tree-container .tree-node .slim-submenu-container ul{list-style:none;margin:0;padding-left:0}.sidebar.slim-bar .tree-container .tree-node .slim-submenu-container li{display:flex;align-items:center;padding:18px 24px 18px 40px;cursor:pointer}.sidebar.slim-bar .tree-container .tree-node .slim-submenu-container li.disabled{color:gray;cursor:default!important}.sidebar.slim-bar .tree-container .tree-node .slim-submenu-container li.selected{background-color:var(--geaui-grey-03);color:var(--geaui-vibrant-blue)}.sidebar.slim-bar .tree-container .tree-node .slim-submenu-container .slim-submenu div{display:flex;align-items:center}.sidebar.slim-bar .tree-container .tree-node .node-label{margin-left:8px;font-size:16px;font-weight:500;line-height:130%}.sidepanel{position:absolute;background-color:#fff;top:60px;width:100%;height:calc(100vh - 60px);transition:left .5s,width .5s;padding:17px;z-index:3}.sidepanel.full{left:258px;width:calc(100% - 258px);transition:left .5s,width .5s}.sidepanel.slim{left:73px;width:calc(100% - 73px);transition:left .5s,width .5s}.sidepanel.mobile{left:0;width:100%;transition:left .5s,width .5s}.sidepanel .close-container{width:100%;padding-bottom:10px;padding-right:12px;display:flex;justify-content:flex-end}.sidepanel .close-container geaui-icon-v2{cursor:pointer}.sidebar-full-page{display:flex;flex-direction:row;width:100%;height:100%;position:relative}.mobile-view-open .sidebar{width:100vw}.mobile-view-open .tree-container{padding-top:4px}.mobile-view-open.sidebar-full-page{position:absolute;height:calc(100vh - 60px)}.tree-node.disabled .nav-item-name .geaui-icon-v2,.tree-node.disabled .nav-item-name .node-label{color:gray;pointer-events:none}.tree-node:not(.disabled){cursor:pointer}.slim-submenu div{display:flex;align-items:center}.node-ellipsis{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;overflow:hidden;width:170px;overflow-wrap:break-word;-moz-hyphens:auto}\n"]
    }]
  }], () => [{
    type: i1.Router
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i2.DialogV2Service
  }, {
    type: i0.DestroyRef
  }, {
    type: i3.BreakpointObserver
  }, {
    type: i4.HeaderUtilService
  }, {
    type: i2.ComplexDialogV2Service
  }, {
    type: i2.ComplexDialogV3Service
  }, {
    type: i5.ContactFormService
  }], {
    devisionIconPath: [{
      type: Input
    }],
    devisionIconBackgroundColor: [{
      type: Input
    }],
    devisionName: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    navigationItems: [{
      type: Input
    }],
    adminViewNavigationItems: [{
      type: Input
    }],
    hasSearch: [{
      type: Input
    }],
    slimView: [{
      type: Input
    }],
    bottomNavigation: [{
      type: Input
    }],
    customActionTriggered: [{
      type: Output
    }],
    changeViewDropdown: [{
      type: ViewChild,
      args: ['changeViewDropdown']
    }],
    onClickOutside: [{
      type: HostListener,
      args: ['document:click', ['$event.target']]
    }]
  });
})();
